import { ImgHTMLAttributes } from 'react';
import { GameData, STORAGE_URL } from 'react-easyrocket';
import { useHideBlockedImage } from './hooks/useHideBlockedImage';
const STORAGE_FOR_GAMES = '/storage/games/vertically';

interface GameImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  className?: string;
  game: GameData;
}

export const GameImage = ({ className, game = {} as GameData, ...props }: GameImageProps) => {
  const isHideBlockedImage = useHideBlockedImage({ game });
  const { imagine, image, name } = game;
  const desktopSrc = isHideBlockedImage ? imagine?.files?.mobile : imagine?.files?.desktop;
  const mobileSrc = imagine?.files?.mobile;
  const defaultSrc = STORAGE_URL + STORAGE_FOR_GAMES + image;
  const imageAlt = imagine?.alt || name;

  return (
    <picture>
      {desktopSrc && <source media="(min-width:1024px)" srcSet={desktopSrc} />}
      {mobileSrc && <source media="(max-width:1023px)" srcSet={mobileSrc} />}
      <img
        src={defaultSrc}
        alt={imageAlt}
        title={name}
        draggable={false}
        decoding="async"
        className={className}
        {...props}
      />
    </picture>
  );
};
